import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Final ordering — identity → offer → immersion → invitation.  Journal sits
// before the CTA so the brand world precedes the call-to-action.  Guides has
// been removed from primary navigation per Wave 2; it remains reachable from
// inside Journal articles and the resources surface in the footer.
const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'Philosophy' },
  { path: '/services', label: 'Services' },
  { path: '/destinations', label: 'Destinations' },
  { path: '/blog', label: 'Journal' },
];

const CTA = { path: '/plan', label: 'Begin Your Experience' };

export function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="w-full border-b border-[#E8E4DC] bg-[#FAFAF8]" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        {/* Brand */}
        <Link to="/" className="font-serif text-xl tracking-wide text-[#1A1A1A]" data-testid="public-nav-brand">
          V&Eacute;RAULT Travels
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-wide transition-colors ${
                isActive(link.path)
                  ? 'text-[#1A1A1A]'
                  : 'text-[#6B6B6B] hover:text-[#1A1A1A]'
              }`}
              data-testid={`public-nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop right rail — CTA + login */}
        <div className="hidden lg:flex items-center gap-6">
          <Link
            to={CTA.path}
            className={`text-sm tracking-wide transition-colors border-b border-transparent hover:border-[#C9A961] pb-0.5 ${
              isActive(CTA.path) ? 'text-[#1A1A1A] border-[#C9A961]' : 'text-[#1A1A1A]'
            }`}
            data-testid="public-nav-begin-your-experience"
          >
            {CTA.label}
          </Link>
          {/* Wave 12.q — Suite Access removed from public nav.
              Login is advisor-only via /owner-access on travel.verault.co.
              Clients enter via their door slug. */}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="lg:hidden p-2 text-[#1A1A1A]"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          data-testid="public-nav-mobile-toggle"
        >
          <div className="w-5 flex flex-col gap-[5px]">
            <span className={`block h-[1.5px] bg-[#1A1A1A] transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-[6.5px]' : ''}`} />
            <span className={`block h-[1.5px] bg-[#1A1A1A] transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
            <span className={`block h-[1.5px] bg-[#1A1A1A] transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-[6.5px]' : ''}`} />
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-[#E8E4DC] bg-[#FAFAF8]" data-testid="public-nav-mobile-menu">
          <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map(link => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`text-sm tracking-wide transition-colors ${
                  isActive(link.path) ? 'text-[#1A1A1A]' : 'text-[#6B6B6B]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to={CTA.path}
              onClick={() => setMobileOpen(false)}
              className="text-sm tracking-wide text-[#1A1A1A] border-b border-[#C9A961] pb-1 w-fit"
              data-testid="public-nav-mobile-begin-your-experience"
            >
              {CTA.label}
            </Link>
            {/* Wave 12.q — Suite Access removed from mobile nav. */}
          </nav>
        </div>
      )}
    </header>
  );
}
